import numeral from 'numeral'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

function getFormattedDimensions(length, width, height) {
  // Dimensions are optional (may return null or 0 from the API)
  // but we have to preserve order (LxWxH) still if any of them is missing.
  let formattedDimensions = []
  if (length) formattedDimensions.push(`${length}' L`)
  if (width) formattedDimensions.push(`${width}' W`)
  if (height) formattedDimensions.push(`${height}' H`)
  return formattedDimensions.join(' x ')
}

const Wrapper = styled.div`
  display: inline-block;

  ${({ truncate }) =>
    truncate &&
    `
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    `};
`

const Dimensions = styled.span``

const Weight = styled.span`
  font-weight: ${({ bold }) => (bold ? 'bold' : '')};
`

const Commodity = styled.span`
  font-weight: ${({ bold }) => (bold ? 'bold' : '')};
`

function Cargo(props) {
  const { weight, commodity, dimensions, boldWeight, truncate, ...rest } = props
  const { length, width, height } = dimensions || {}
  const hasDimensions = Boolean(length || width || height)

  const formattedDimensions = hasDimensions && getFormattedDimensions(length, width, height)

  return (
    <Wrapper truncate={truncate} {...rest}>
      {hasDimensions && (
        <Dimensions>
          {formattedDimensions}
          &nbsp;/&nbsp;
        </Dimensions>
      )}
      <Weight bold={boldWeight}>{numeral(weight).format('0,0')} lbs</Weight>
      &nbsp;
      {commodity && <Commodity title={commodity}>of {commodity}</Commodity>}
    </Wrapper>
  )
}

Cargo.propTypes = {
  weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  commodity: PropTypes.string,
  boldWeight: PropTypes.bool,
  truncate: PropTypes.bool,
  dimensions: PropTypes.shape({
    height: PropTypes.number,
    length: PropTypes.number,
    width: PropTypes.number,
  }),
}

Cargo.defaultProps = {
  commodity: null,
  boldWeight: false,
  truncate: false,
  dimensions: null,
}

export { Cargo }
